// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3MnKi","title":"style_title__3uuGv","editButtonWrapper":"style_editButtonWrapper__38rjo"};